export default {
  sm: `
  Data center that holds<br>
  the future 
  `,
};
